var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDownload = function SvgIconDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.002 1v9.74M11.5 7.086 8 10.74M4.5 7.086 8 10.74",
    stroke: "#251447",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.957V13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1.043",
    stroke: "#251447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgIconDownload as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+Cgk8cGF0aCBkPSJNOC4wMDE5NSAxTDguMDAxOTUgMTAuNzM5MSIgc3Ryb2tlPSIjMjUxNDQ3IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cgk8cGF0aCBkPSJNMTEuNTAwNSA3LjA4NjQzTDguMDAwNDkgMTAuNzM4NiIgc3Ryb2tlPSIjMjUxNDQ3IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cgk8cGF0aCBkPSJNNC40OTk1MSA3LjA4NjQzTDcuOTk5NTEgMTAuNzM4NiIgc3Ryb2tlPSIjMjUxNDQ3IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cgk8cGF0aCBkPSJNMSAxMS45NTY1VjEzQzEgMTQuMTA0NiAxLjg5NTQzIDE1IDMgMTVIMTNDMTQuMTA0NiAxNSAxNSAxNC4xMDQ2IDE1IDEzVjExLjk1NjUiIHN0cm9rZT0iIzI1MTQ0NyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";